<content-loader height="475" width="400" viewBox="0 0 400 475">
  <svg:rect x="0" y="0" rx="4" ry="4" width="100" height="10" />
  <svg:rect x="0" y="15" rx="4" ry="4" width="400" height="10" />
  <svg:rect x="0" y="30" rx="4" ry="4" width="400" height="10" />
</content-loader>
